import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as faFunctionCategory from './category'
import * as faFunctionSubcategory from './subcategory'

export const DOC = gql`
  ${faFunctionCategory.DOC}
  ${faFunctionSubcategory.DOC}
  fragment FragmentFaFunctionCategorization on FaFunctionCategorization {
    category {
      ...FragmentFaFunctionCategory
    }
    subcategory {
      ...FragmentFaFunctionSubcategory
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentFaFunctionCategorizationFragment,
  ents.extra.common.FaFunction.Categorization
>({
  category: graphql.transformers.OUT.validate(
    faFunctionCategory.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  subcategory: faFunctionSubcategory.TRANSFORMER,
})
